import { Link } from 'react-router-dom';
import { newComics } from '@/mocks/comics';

export default function LatestUpdates() {
  const featured = newComics.slice(0, 2);

  if (featured.length < 2) return null;

  return (
    <section id="latest" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
          <div className="w-full lg:w-[45%]">
            <span className="inline-block text-xs font-medium text-primary-600 bg-primary-100/70 px-3 py-1 rounded-full mb-4">
              最新更新
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-4">
              新鲜出炉，
              <br />
              抢先一步看新番
            </h2>
            <p className="text-foreground-600 text-base leading-relaxed mb-6 max-w-md">
              每日精选最新更新的漫画作品，让你不错过任何精彩章节。
              追更无需等待，好故事持续放送中。
            </p>
            <Link
              to="/category/rexue"
              className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
            >
              查看全部更新
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="w-full lg:w-[55%] flex gap-4 md:gap-6">
            {featured.map((comic, idx) => (
              <Link
                key={comic.id}
                to={`/comic/${comic.slug}`}
                className={`relative group rounded-2xl overflow-hidden flex-1 ${
                  idx === 0 ? 'h-72 md:h-96' : 'h-72 md:h-80 mt-6 md:mt-16'
                }`}
              >
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 哔咔漫画最新更新`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <span className="inline-block text-xs bg-accent-500 text-background-50 px-2 py-0.5 rounded-full mb-2">
                    {comic.category}
                  </span>
                  <h3 className="font-heading text-lg md:text-xl text-background-50 font-bold mb-1">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-background-50/70">{comic.updateChapter}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}